export default class Enterprise {
  id!: number;
  name!: string;
  logo!: string;
  domain?: string;
}
